import { render, staticRenderFns } from "./ModalInsuranceObject.vue?vue&type=template&id=1ad68456"
import script from "./ModalInsuranceObject.vue?vue&type=script&lang=js"
export * from "./ModalInsuranceObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports